(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tcc-cart-picks"] && !Shopify.designMode) return;
  try {
    if (!window.tccCartPicksReady) {
    window.tccCartPicksReady = true;
    document.addEventListener('click', (event) => {
      const tab = event.target.closest('[data-tcc-picks-tab]');
      if (!tab) return;
      const root = tab.closest('[data-tcc-cart-picks]');
      const selected = tab.dataset.tccPicksTab;
      root.querySelectorAll('[data-tcc-picks-tab]').forEach((button) => {
        const active = button.dataset.tccPicksTab === selected;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      root.querySelectorAll('[data-tcc-picks-panel]').forEach((panel) => {
        const active = panel.dataset.tccPicksPanel === selected;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tcc-store-reviews"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialise = (root) => {
      if (!root || root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      const list = root.querySelector('[data-review-list]');
      const cards = [...root.querySelectorAll('.tcc-review')];
      const filters = [...root.querySelectorAll('[data-rating]')].filter((element) => element.classList.contains('tcc-reviews__bar'));
      const sort = root.querySelector('[data-review-sort]');
      const more = root.querySelector('[data-review-more]');
      const status = root.querySelector('[data-review-status]');
      let activeRating = 'all';
      let expanded = false;

      const render = () => {
        const matching = cards.filter((card) => activeRating === 'all' || card.dataset.rating === activeRating);
        cards.forEach((card) => { card.hidden = true; });
        matching.slice(0, expanded ? matching.length : 3).forEach((card) => { card.hidden = false; });
        status.textContent = `${root.dataset.statusShowing} ${Math.min(expanded ? matching.length : 3, matching.length)} ${root.dataset.statusOf} ${matching.length} ${root.dataset.statusSuffix}`;
        more.hidden = expanded || matching.length <= 3;
      };

      filters.forEach((filter) => {
        filter.addEventListener('click', () => {
          activeRating = filter.dataset.rating;
          expanded = false;
          filters.forEach((item) => {
            const selected = item === filter;
            item.classList.toggle('is-active', selected);
            item.setAttribute('aria-pressed', selected ? 'true' : 'false');
          });
          render();
        });
      });

      sort.addEventListener('change', () => {
        const sorted = [...cards].sort((a, b) => {
          if (sort.value === 'highest') return Number(b.dataset.rating) - Number(a.dataset.rating) || Number(a.dataset.order) - Number(b.dataset.order);
          if (sort.value === 'lowest') return Number(a.dataset.rating) - Number(b.dataset.rating) || Number(a.dataset.order) - Number(b.dataset.order);
          return Number(a.dataset.order) - Number(b.dataset.order);
        });
        sorted.forEach((card) => list.append(card));
        render();
      });

      more.addEventListener('click', () => {
        expanded = true;
        render();
      });

      render();
    };

    document.querySelectorAll('[data-tcc-reviews]').forEach(initialise);
    document.addEventListener('shopify:section:load', (event) => initialise(event.target.querySelector('[data-tcc-reviews]')));
  })();
  } catch(e) { console.error(e); }
})();

})();
